<template>
  <div class="ml-auto py-2 pl-2">
    <div class="d-flex justify-content-end align-items-center">
      
      <div v-if="mediaType != 'category'" class="d-flex align-items-center">
        <!-- ADD BUTTON -->
         <b-dropdown variant="primary" class="mx-2" no-caret>
          <template slot="button-content">
            <span class="d-flex align-items-center font-weight-bold">
              <font-awesome-icon icon="plus-circle" class="mr-2"/>
              <span>Add New</span>
            </span>
          </template>

          <b-dropdown-item href="#" @click="$store.dispatch('media/addNewItem', {type: 'artist_page'})">
            <Icon icon="Menu_Categories"/>
            <span class="ml-2">Artist Page</span>
          </b-dropdown-item>
          <b-dropdown-item href="#" @click="$store.dispatch('media/addNewItem', {type: 'audio'})">
            <Icon icon="Menu_audio"/>
            <span class="ml-2">Audio</span>
          </b-dropdown-item>
          <b-dropdown-item href="#" @click="$store.dispatch('media/addNewItem', {type: 'book'})">
            <Icon icon="Menu_books"/>
            <span class="ml-2">Book</span>
          </b-dropdown-item>
          <b-dropdown-item href="#" @click="$store.dispatch('media/addNewItem', {type: 'brand'})">
            <Icon icon="Menu_Brands"/>
            <span class="ml-2">Brand</span>
          </b-dropdown-item>
          <b-dropdown-item href="#" @click="$store.dispatch('media/addNewItem', {type: 'external'})">
            <Icon icon="Menu_externals"/>
            <span class="ml-2">External</span>
          </b-dropdown-item>
          <b-dropdown-item href="#" @click="$store.dispatch('media/addNewItem', {type: 'magazine'})">
            <Icon icon="Menu_Magazines"/>
            <span class="ml-2">Magazine</span>
          </b-dropdown-item>
          <b-dropdown-item href="#" @click="$store.dispatch('media/addNewItem', {type: 'page'})">
            <Icon icon="Menu_Categories"/>
            <span class="ml-2">Micropage</span>
          </b-dropdown-item>
          <b-dropdown-item href="#" @click="$store.dispatch('media/addNewItem', {type: 'music_album'})">
            <Icon icon="Menu_music"/>
            <span class="ml-2">Music Album</span>
          </b-dropdown-item>
          <b-dropdown-item href="#" @click="$store.dispatch('media/addNewItem', {type: 'photo_package'})">
            <Icon icon="Menu_camera"/>
            <span class="ml-2">Photo Package</span>
          </b-dropdown-item>
          <b-dropdown-item href="#" @click="$store.dispatch('media/addNewItem', {type: 'playlist_page'})">
            <Icon icon="Menu_Categories"/>
            <span class="ml-2">Playlist Page</span>
          </b-dropdown-item>
          <b-dropdown-item href="#" @click="$store.dispatch('media/addNewItem', {type: 'podcast'})">
            <Icon icon="Menu_podcast"/>
            <span class="ml-2">Podcast</span>
          </b-dropdown-item>
          <b-dropdown-item href="#" @click="$store.dispatch('media/addNewItem', {type: 'series'})">
            <Icon icon="Menu_Series"/>
            <span class="ml-2">Series</span>
          </b-dropdown-item>
          <b-dropdown-item href="#" @click="$store.dispatch('media/addNewItem', {type: 'video'})">
            <Icon icon="Menu_Videos"/>
            <span class="ml-2">Video</span>
          </b-dropdown-item>

          <b-dropdown-divider/>

          <b-dropdown-item id="import-button" text="Import" @click="$store.commit('media/updateModal', {import: {visible: true, insert: false}})">
            <Icon icon="import"/>
            <span class="ml-2">Import from Excel</span>
          </b-dropdown-item>
          
           <b-dropdown-item v-if="$config.allowInsertFromExcel" id="import-new-button" text="Import New" @click="$store.commit('media/updateModal', {import: {visible: true, insert: true}})">
            <Icon icon="import"/>
            <span class="ml-2">Import new content from Excel</span>
          </b-dropdown-item>
        </b-dropdown>

        <div class="mx-2 text-muted opacity-50">|</div>

        <!-- ACTIONS DROPDOWN -->
        <b-dropdown variant="link" class="mx-1" no-caret>
          <template slot="button-content">
            <span class="d-flex align-items-center">
              <span class="mr-1">Actions</span>
              <font-awesome-icon icon="chevron-down" size="xs"/>
            </span>
          </template>

         <b-dropdown-item id="export-button" @click="$root.$emit('media-export', true)">
            <font-awesome-icon icon="file-export"/>
            <span class="ml-2">Export to Excel</span>
          </b-dropdown-item>

          <b-dropdown-item id="duplicate-button" @click="handleDuplicate">
            <font-awesome-icon icon="clone"/>
            <span class="ml-2">Duplicate</span>
          </b-dropdown-item>

          <b-dropdown-item @click="handleArchive">
            <font-awesome-icon icon="archive"/>
            <span class="ml-2">Archive</span>
          </b-dropdown-item>

          <b-dropdown-item @click="manageMediaLabels">
            <font-awesome-icon icon="tags"/>
            <span class="ml-2">Manage Labels</span>
          </b-dropdown-item>

          <b-dropdown-item v-if="$config.enableArtistsEverywhere" @click="manageMediaArtists">
            <font-awesome-icon icon="user"/>
            <span class="ml-2">Manage Artists</span>
          </b-dropdown-item>

          <b-dropdown-item v-if="$config.enableGenres" @click="manageMediaGenres">
            <font-awesome-icon icon="tags"/>
            <span class="ml-2">Manage Genres</span>
          </b-dropdown-item>

          <b-dropdown-item @click="manageMediaProperties">
            <font-awesome-icon icon="square-check"/>
            <span class="ml-2">Manage Properties</span>
          </b-dropdown-item>

          <b-dropdown-item @click="handlePublishCheck">
            <font-awesome-icon icon="globe"/>
            <span class="ml-2">Publish check</span>
          </b-dropdown-item>
        </b-dropdown>

        <div class="mx-2 text-muted opacity-50">|</div>

        <!-- LABELS FILTER TRIGGER -->
         <button @click="$refs.mediaLabelFilter.show()" class="btn btn-link mx-1 d-flex align-items-center" aria-haspopup="true" aria-expanded="false">
          <font-awesome-icon icon="tags" class="mr-2"/>
          <span>Labels</span>
          <font-awesome-icon icon="chevron-down" size="xs" class="ml-1"/>
        </button>

        <EditLabels :labels="$store.state.media.labelFilter" @update="$store.dispatch('media/setLabelFilter', $event)" ref="mediaLabelFilter" :allow-new="false" :allow-manage="false"/>

      </div>

      <template v-else-if="$store.state.media.selectedIds.length == 1 && $store.state.media.selectedIds[0] != 'root'">
        <template v-if="$store.state.media.categoryIdToCopy == null">
          <b-button @click="handleCopyCategory" size="sm" variant="info" class="mr-2">
            <Icon icon="Copy_id"/>
            Copy
          </b-button>
        </template>
        <b-button-group v-else class="mr-2">
          <b-button @click="$store.commit('media/resetCategoryIdToCopy')" variant="warning" size="sm">
            <font-awesome-icon icon="times"/>
            Clear
          </b-button>
          <b-button v-if="$store.state.media.categoryIdToCopy != null" @click="handlePasteCategory" size="sm" variant="success">
            <Icon icon="Copy_id"/>
            Paste
          </b-button>
        </b-button-group>
      </template>

    </div>
  </div>
</template>

<script>
import EditLabels from './EditLabels.vue'

export default {
  name: "MediaToolbar",

  components: {
    EditLabels
  },

  props: {
    mediaType: String
  },

  methods: {
    handleArchive() {
      if(this.$store.state.media.selectedIds.length > 0) {
        this.$store.commit('media/updateModal', {archive: {visible: true}})
      }
    },

    handleDuplicate() {
      if(this.$store.state.media.selectedIds.length > 0) {
        this.$store.dispatch('media/duplicateItem', this.$store.state.media.selectedIds[0])
      }
    },

    handlePublishCheck() {
      this.$store.dispatch('media/publishCheck')
        .then(resp => {
          this.$store.dispatch('media/publishCheckResults', {
            status: resp.json.data.status,
            results: resp.json.data.results,
            isSaveResult: false
          })
        })
        .catch(error => this.$root.app.showAlert(error.text, "danger"))

    },

    handleCopyCategory() {
      this.$store.commit('media/copySelectedCategory')
    },

    handlePasteCategory() {
      this.$store.dispatch('media/pasteCategory')
        .catch(() => this.$root.app.showAlert("This action is not allowed", "danger"))
    },

    manageMediaLabels() {
      if(this.$store.state.media.selectedIds.length > 0) {
        this.$store.dispatch('media/manageMediaLabels')
      }
      else {
        this.$root.app.showAlert("No media items selected", "danger")
      }
    },

    manageMediaArtists() {
      if(this.$store.state.media.selectedIds.length > 0) {
        this.$store.dispatch('media/manageMediaArtists')
      }
      else {
        this.$root.app.showAlert("No media items selected", "danger")
      }
    },

    manageMediaGenres() {
      if(this.$store.state.media.selectedIds.length > 0) {
        this.$store.dispatch('media/manageMediaGenres')
      }
      else {
        this.$root.app.showAlert("No media items selected", "danger")
      }
    },

    manageMediaProperties() {
      if(this.$store.state.media.selectedIds.length > 0) {
        this.$store.dispatch('media/manageMediaProperties')
      }
      else {
        this.$root.app.showAlert("No media items selected", "danger")
      }
    }

  }
}
</script>

